module.exports = "/_next/static/images/mackbookImage-f548edbcdbf25b82c4e8afe07d804091.png.webp";